export default __webpack_public_path__ + "static/media/white-tick.f21d4589.svg";